<script lang="ts" setup>
  import { computed, ref, watch } from 'vue'

  const props = defineProps<{
    expires: number | null
  }>()

  const emits = defineEmits<{
    login: []
  }>()

  const sessionExpirationInMinutes = ref(24 * 60)

  const sessionExpiring = computed(() => {
    return sessionExpirationInMinutes.value <= 30
  })

  let sessionExpirationInterval: number | null = null

  watch(
    () => props.expires,
    () => {
      if (sessionExpirationInterval) {
        clearInterval(sessionExpirationInterval)
      }

      sessionExpirationInterval = window.setInterval(() => {
        if (props.expires) {
          const diff = props.expires - Date.now()

          sessionExpirationInMinutes.value = Math.max(0, Math.round(diff / 60 / 1000))
        }
      }, 1 * 1000)
    },
    { immediate: true },
  )
</script>

<template lang="html">
  <v-footer v-if="sessionExpiring" app border class="pa-0" elevation="1" :order="2">
    <o-alert tile type="info">
      Your session is expiring in
      <b>{{ sessionExpirationInMinutes }}</b>
      minutes, please refresh your session by
      <a href="#" class="text-info font-weight-bold" @click="emits('login')">logging in</a>
      again or you will be logged out automatically.
    </o-alert>
  </v-footer>
</template>
